import { z } from 'zod';

/**
 * Form values do Step 2 (Pagamento) — Capital Global / categoria OTHER.
 * Validação em tempo real nos `validators` do TanStack Form; Zod centraliza o shape.
 */
export const capitalGlobalProposalStepPagamentoSchema = z.object({
  premiumPeriodicity: z.string(),
  paymentMethod: z.string(),
  bestDueDay: z.string(),
  agency: z.string(),
  agencyDigit: z.string(),
  account: z.string(),
  accountDigit: z.string(),
});

export type CapitalGlobalProposalStepPagamentoValues = z.infer<
  typeof capitalGlobalProposalStepPagamentoSchema
>;

export const capitalGlobalProposalStepPagamentoDefaultValues: CapitalGlobalProposalStepPagamentoValues =
  {
    premiumPeriodicity: 'annual',
    paymentMethod: '',
    bestDueDay: '',
    agency: '',
    agencyDigit: '',
    account: '',
    accountDigit: '',
  };
